var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.definitions)?_c('definition-cards',{attrs:{"loading":!_vm.definitions,"definitions":_vm.definitions,"activeStore":_vm.active_store},on:{"period":_vm.handlePeriod}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }